import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import SliceZone from "../components/SliceZone";

export const PrivateClients = ({ data }) => {
  if (!data) return null;
  const header = data.prismicHeaderitem || {};
  const footer = data.prismicFooteritem || {};
  const { lang, type, url } = header || {};
  const alternateLanguages = header.alternate_languages || [];
  const activeDoc = {
    lang,
    type,
    url,
    alternateLanguages,
  };

  const privateClient = data.prismicPrivateclient || {};

  return (
    <Layout
      activeDocMeta={activeDoc}
      body={header}
      bodyFooter={footer}
      fullPage={false}
    >
      <SliceZone slices={privateClient.data.body} />
    </Layout>
  );
};

export const query = graphql`
  query privateClientQuery($lang: String) {
    prismicPrivateclient(lang: { eq: $lang }) {
      lang
      url
      data {
        body {
          ... on PrismicPrivateclientBodyHeroSection {
            id
            primary {
              button {
                text
              }
              button_link {
                url
              }
              subtitle {
                raw
              }
              title {
                text
              }
              background_image {
                url
              }
              background_image_position {
                text
              }
              pulse_animation
            }
            internal {
              content
              description
              ignoreType
              mediaType
            }
            slice_type
            slice_label
          }
          ... on PrismicPrivateclientBodyLargeTestimonialSection {
            id
            primary {
              title1 {
                text
              }
              text2 {
                text
              }
              text1 {
                text
              }
              section_number {
                text
              }
              section_name {
                text
              }
              section_image {
                url
              }
              button1 {
                text
              }
              button_link {
                url
              }
              text_button {
                text
              }
            }
            internal {
              content
              description
              ignoreType
              mediaType
            }
            slice_type
            slice_label
          }
          ... on PrismicPrivateclientBodyOutstandingResults {
            id
            slice_type
            primary {
              subtitle {
                text
              }
              title {
                text
              }
            }
            items {
              slider_item {
                text
              }
            }
          }
          ... on PrismicPrivateclientBody5Advantages {
            id
            slice_type
            primary {
              button_text {
                text
              }
              button_link {
                url
              }
              subtitle {
                text
              }
              title {
                text
              }
            }
            items {
              text {
                text
              }
              title {
                text
              }
            }
          }
          ... on PrismicPrivateclientBody6Future {
            id
            slice_type
            primary {
              button_text {
                text
              }
              button_link {
                url
              }
              subtitle {
                text
              }
              title {
                text
              }
            }
          }
          ... on PrismicPrivateclientBodyProtectAndGrow {
            id
            slice_type
            primary {
              subtitle {
                text
              }
              title {
                text
              }
            }
            items {
              link_text {
                text
              }
              text {
                text
              }
            }
          }
          ... on PrismicPrivateclientBody8DeserveBatter {
            id
            slice_type
            primary {
              button_text {
                text
              }
              button_link {
                url
              }
              subtitle {
                text
              }
              title {
                text
              }
            }
          }
          ... on PrismicPrivateclientBody9InvestmentSlider {
            id
            slice_type
            primary {
              subtitle {
                text
              }
              title {
                text
              }
              background_text {
                text
              }
            }
            items {
              label {
                text
              }
              text {
                text
              }
            }
          }
          ... on PrismicPrivateclientBodyOutstandingProducts {
            id
            primary {
              cta_text {
                text
              }
              button_link {
                url
              }
              section_number {
                text
              }
              section_title {
                text
              }
              title {
                text
              }
              background_image {
                url
              }
            }
            slice_label
            slice_type
          }
          ... on PrismicPrivateclientBodyTextureSection {
            id
            slice_type
            primary {
              buttontext {
                text
              }
              emailtext {
                text
              }
              title {
                text
              }
            }
          }
        }
      }
    }
    prismicHeaderitem(lang: { eq: $lang }) {
      lang
      type
      url
      alternate_languages {
        lang
        type
      }
      data {
        button {
          text
        }
        item1 {
          text
        }
        item2 {
          text
        }
        item3 {
          text
        }
        aboutus {
          aboutus_name {
            text
          }
        }
        item4 {
          text
        }
        item5 {
          text
        }
        item6 {
          text
        }
        item7 {
          text
        }
        solutions {
          solution_name {
            text
          }
        }
        products {
          product_name {
            text
          }
        }
        cookie_consent {
          raw
        }
      }
    }
    prismicFooteritem(lang: { eq: $lang }) {
      url
      type
      lang
      alternate_languages {
        lang
        type
      }
      data {
        about {
          text
        }
        allrights {
          text
        }
        item1 {
          text
        }
        item2 {
          text
        }
        item3 {
          text
        }
        item4 {
          text
        }
        item5 {
          text
        }
        item6 {
          text
        }
        item7 {
          text
        }
        privacy {
          text
        }
        terms {
          text
        }
        clientinformation {
          text
        }
        impressum {
          text
        }
      }
    }
  }
`;

export default PrivateClients;
